import { subject } from '@casl/ability';

/**
 * Builds the CASL subject for a diary record.
 *
 * Every DailyDiary rule in the api's acl.js is conditional on
 * `{ project_id: { $in: [...] } }` (it registers both numeric ids and uuids),
 * but the api serializes the project as a NESTED OBJECT and never sends a flat
 * `project_id`. Passing the raw record therefore matched no rule: every draft
 * opened read-only and the delete controls never rendered.
 */
export function dailyDiarySubject(diary: any) {
  return subject('DailyDiary', {
    ...diary,
    project_id: diary?.project_id ?? diary?.project?.id ?? diary?.project?.uuid,
    site_id: diary?.site_id ?? diary?.site?.id ?? diary?.site?.uuid,
  });
}

/**
 * Subject for "can this user start a NEW diary here?".
 *
 * There is no record yet, so the only thing the acl rules can match on is the
 * project/site pair. Kept next to `dailyDiarySubject` so every diary ability
 * check in the app goes through this one file.
 */
export function dailyDiaryCreateSubject(projectId: string, siteId?: string) {
  return subject('DailyDiary', {
    project_id: projectId,
    ...(siteId ? { site_id: siteId } : {}),
  });
}
